import { render, staticRenderFns } from "./header-slider.vue?vue&type=template&id=497472fe&scoped=true&lang=pug&"
import script from "./header-slider.vue?vue&type=script&lang=js&"
export * from "./header-slider.vue?vue&type=script&lang=js&"
import style0 from "./header-slider.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./header-slider.vue?vue&type=style&index=1&id=497472fe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497472fe",
  null
  
)

export default component.exports